// extracted by mini-css-extract-plugin
module.exports = {"container":"Hospital_container__1RpEG","top":"Hospital_top__14cLl","title":"Hospital_title__3Sn5j","tableContainer":"Hospital_tableContainer__2aaXS"};